/**
 * 簡単なキャッシュ
 * TypeScriptで書きたいのだがコンパイルエラーになるためJSで書いている
 */
import arrayHelper from "./array-helper";

/**
 * キャッシュアイテムポリシー
 * 今の所、有効期限のみ 
 */
// function CacheItemPolicy() {
//     this.expire = null;
// }
// CacheItemPolicy.prototype.setExpirationSeconds = function(sec) {
//     let dt = new Date();
//     dt.setSeconds(dt.getSeconds() + sec);
//     this.expire = dt;
// }

// /**
//  * キャッシュアイテム
//  * 値とポリシー
//  */
// function CacheItem() {
//     this.value = null;
//     this.policy = new CacheItemPolicy();
// }

// /**
//  * キャッシュ機能
//  */
// function SimpleCache() {
//     this._cache = new Map();
// }
// SimpleCache.prototype.set = function(key, value) {
//     this.setWithSeconds(key, value, 60);
// }
// SimpleCache.prototype.setWithSeconds = function(key, value, sec) {
//     let item = new CacheItem();
//     item.value = value;
//     item.policy.setExpirationSeconds(sec);
//     this._cache.set(key, item);
// }
// SimpleCache.prototype.get = function(key) {

//     if (!this._cache.has(key)) {
//         return null;
//     }

//     let item = this._cache.get(key);

//     if (item.policy.expire < new Date()) {
//         return null;
//     }

//     return item.value;
// }

// var Cache = new SimpleCache();

// export default Cache;



class SimpleCache {
    private _cache: Map<string, CacheItem>;

    constructor() {
        this._cache = new Map<string, CacheItem>();
    }

    /**
     * キャッシュに値をセットします。
     * @param key キー
     * @param value 値
     * @param sec キャッシュを保持する時間(秒)。省略した場合はデフォルト(60秒)
     */
    set(key: string, value: any, sec?: number): void {
        let item = new CacheItem(value, sec);
        this._cache.set(key, arrayHelper.clone(item))
    }

    setWithPolicy(key: string, value: any, policy: CacheItemPolicy): void {
        let item = new CacheItem(value, policy);
        this._cache.set(key, arrayHelper.clone(item))
    }

    has(key: string): boolean {
        return this._cache.has(key);
    }

    get(key: string): any | null {

        if (!this._cache.has(key)) {
            return null;
        }

        let item = this._cache.get(key);

        if (item.policy.expire < new Date()) {
            return null;
        }

        return arrayHelper.clone(item.value); // オブジェクトだとアドレスが同じ？になっちゃうため
    }

    clear(key: string) {
        if (this._cache.has(key)) {
            this._cache.delete(key)
        }
    }

    /**
     * 指定された文字列から始まるキーを持つキャッシュをすべて削除します。
     * @param testStartsWith 
     */
    clearStartsWith(keyStartsWith: string) {
        const deleteKeys = [...this._cache.keys()].filter(x => x.startsWith(keyStartsWith))
        for (const deleteKey of deleteKeys) {
            this._cache.delete(deleteKey)
        }
    }
}

class CacheItem {
    value: any;
    policy: CacheItemPolicy;

    constructor(val: any)
    constructor(val: any, sec: number)
    constructor(val: any, policy: CacheItemPolicy)
    constructor(val: any, policy?: number | CacheItemPolicy) {
        this.value = val;
        if (policy == null) {
            this.policy = new CacheItemPolicy(60)
        } else if (typeof policy == "number") {
            this.policy = new CacheItemPolicy(policy)
        } else {
            this.policy = policy
        }
    }
}

class CacheItemPolicy {
    expire: Date = null;
    setAbsoluteExpiration(dt: Date) {
        this.expire = dt;
    }
    setExpirationSeconds(sec: number) {
        let dt = new Date();
        dt.setSeconds(dt.getSeconds() + sec);
        this.expire = dt;
    }

    constructor(sec: number) {
        this.setExpirationSeconds(sec)
    }
}

var Cache = new SimpleCache();

export default Cache;